import { Stack, Image, Label } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/pokemon.module.scss';
import { TSet } from '../constants/types';
import { NavLink } from 'react-router-dom';
import GlobalContext from '../_contexts/GlobalContext';

export interface ISetsMenuComponentProps {
    sets: TSet[];
    onSetSelectedSet: Function;
    selectedSetKey: number;
    availableonly: boolean;
}

export interface ISetsMenuComponentState {
    sets : TSet[];
};

const SetsMenuComponent : React.FunctionComponent<ISetsMenuComponentProps> = (props : ISetsMenuComponentProps) => {
    const [sets, setsets] = useState<TSet[]>([]);

    const { GlobalImagesVersion, SHOW_ALL_SET } = useContext(GlobalContext);
    
    useEffect(() => {
        CreateSets();
    },[props.availableonly, props.sets]);

    function CreateSets() {
        let sets : TSet[] = [];
        props.sets.forEach(set => {
            if (set.cardcount > 0) {
                sets.push(set);
            } else if (!props.availableonly) {
                sets.push(set);
            }
        });
        setsets(sets);
    }

    return (
        <div style={{objectFit:"contain"}}>
            {SHOW_ALL_SET && <div className={`${styles.setLogoContainer} ${props.selectedSetKey === -9 ? styles.selectedSetLogoMenu : ""}`}>
                                <NavLink to="/">
                                    <Stack style={{width:"100%",height:window.innerWidth > 950 ? 100 : 40}} horizontalAlign='center' verticalAlign='center' onClick={() => { props.onSetSelectedSet(-9); }}>
                                        <Image className={styles.setLogoMenu} src={process.env.PUBLIC_URL + `/assets/all.webp?v=${GlobalImagesVersion}`} />
                                    </Stack>
                                </NavLink>
                            </div>}
            {sets.map((set,index) => {
                return  <div className={`${styles.setLogoContainer} ${props.selectedSetKey === set.id ? styles.selectedSetLogoMenu : ""}`}>
                            <NavLink to={`/set/${set.name}`}>
                                <Stack style={{width:"100%",height:window.innerWidth > 950 ? 100 : 40}} horizontalAlign='center' verticalAlign='center' onClick={() => { props.onSetSelectedSet(set.id); }}>
                                    {/* <Label className={styles.setLogoMenuCountLabel}>{set.cardcount ? set.cardcount : 0}</Label> */}
                                    <Image className={styles.setLogoMenu} src={process.env.PUBLIC_URL + `/assets/products/${set.id.toString()}/${set.id.toString()}.webp?v=${GlobalImagesVersion}`} alt={set.name} />
                                </Stack>
                            </NavLink>                
                        </div>
            })}
        </div>
    );
}

export default SetsMenuComponent;